import { makeStyles } from "@mui/styles";
import { fontSize, fontWeight } from "../../utils/constants/UI";
import { ERROR } from "../../utils/constants/colors";

export const styles = makeStyles({
  //EmailVerification Css

  borderRed: {
    display: "flex",
    margin: "1rem 0",
    padding: "0.6rem 1rem",
    borderRadius: "6px",
    border: "1px solid #ff4848",
  },
  Radio: {
    color: "#d3dae3",
    padding: 0,
    "&.Mui-checked": {
      color: "#ff4848",
    },
  },
  borderGrey: {
    display: "flex",
    margin: "1rem 0",
    padding: "0.6rem 1rem",
    borderRadius: "6px",
    border: "1px solid #d3dae3",
    alignItems:'center'
  },
  Image: {
    height: "100px",
    width: "100px",
  },
  ImageBorder: {
    width: "153px",
    height: "153px",
    border: `1px solid ${ERROR.W_400}`,
    display: "flex",
    borderRadius: "90px",
    justifyContent: "center",
    alignItems: "center",
  },
  IMMAGE: {
    maxHeight: "20vh",
  },
  contains: {
    display: "flex",
    justifyContent: "flex-end",
    flexDirection: "column",
    height: "50vh",
    padding: "1rem",
  },
  container: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  containers: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  // ENd EmailVerification Css
  container1: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  head: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100vh",
  },
  Top: {
    width: "300px",
    paddingTop: "24px",
  },
  TypoHead: {
    marginLeft: "0.2rem",
  },

  SubHead: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  Head: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
  },
  containLoader: {
    margin: " 5vh",
  },
  title: {
    color: "#102f51",
    fontWeight: "600",
    textAlign: "center",
    fontSize: "clamp(1rem, 1.5vw, 3rem)",
  },
  homeBtn: {
    background: "white",
    border: "1px solid #ff4848",
    padding: "0.5rem 2rem",
    color: "#ff4848",
    borderRadius: "4px",
    fontFamily: "inter_600",
    cursor: "pointer",
  },
  boldTitle: {
    color: "#102f51",
    fontWeight: "bolder",
    textAlign: "center",
    fontSize: "clamp(1rem, 2vw, 3rem)",
  },
  para: {
    margin: "1rem",
    color: "#626b7e",
    fontWeight: "bolder",
    textAlign: "center",
    fontSize: "clamp(0.8rem, 0.8vw, 3rem)",
  },
  flexJustifyCenter: {
    display: "flex",
    justifyContent: "center",
  },
  continueBtn: {
    background: "#ff4848",
    padding: "0.8rem 2rem",
    border: "none",
    color: "white",
    fontSize: "clamp(0.8rem, 0.8vw, 3rem)",
    fontWeight: "700",
    borderRadius: "4px",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  tableBox: {
    margin: "2rem 25%",
  },
  url: {
    fontWeight: "600",
    color: "#102f51",
    fontSize: "16px",
  },
  heading: {
    fontWeight: "700",
    color: "#102f51",
    fontSize: "16px",
  },
  accountsTitle: {
    textAlign: "center",
    color: "#102f51",
    margin: "1rem",
    fontWeight: "600",
    fontSize: "clamp(1rem, 1.2vw, 3rem)",
  },
  containTexts: {
    paddingBottom: "1rem",
    paddingTop: "60px",
  },
  headers: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  containBtns: {
    display: "flex",
    gap: "8px",
    marginRight: "8px",
    // display: "grid",
    width:"100%",
    marginTop: "1rem",
    gridTemplateColumns: "1fr 2fr",
  },
  cancelBtn: {
    border: "1px solid #d3dae3",
    background: "white",
    marginRight: "1rem",
    borderRadius: "4px",
    cursor: "pointer",
  },
  // eachTenantContainer: {
  //   display: "flex",
  //   border: "1px solid #d3dae3",
  //   margin: "1rem 0",
  //   padding: "0.6rem 1rem",
  //   borderRadius: "6px",
  // },

  tenant_url: {
    color: "#102f51",
    alignSelf: "center",
    fontWeight: "600",
    fontSize: "clamp(0.8rem , 0.8vw, 3rem)",
    marginLeft: "1rem",
  },
  privacyLinkSeperatorText: {
    fontSize: "12px",
    fontWeight: "500",
    textDecoration: "none",
    paddingLeft: "4px",
    whiteSpace: "nowrap",
    color: "#626B7E",
  },
  privacyLink: {
    fontSize: fontSize.XS,
    fontWeight: fontWeight.REGULAR,
    lineHeight: "18px",
    // fontFamily: "inter_500",
    textDecoration: "none",
    paddingLeft: "4px",
    whiteSpace: "nowrap",
    color: "#626B7E",
    transition: "100ms",
    "& :hover": {
      color: "#ff4848",
    },
  },
  termsPara: {
    fontSize: fontSize.XS,
    color: "#626B7E",
    fontFamily: "inter_400",
    textAlign: "center",
    whiteSpace: "nowrap",
  },
  logo_container: {
    display: "flex",
    justifyContent: "center",
    paddingTop: "100px",
  },
  containPolicy: {
    paddingTop: "14px",
    // paddingBottom: "38px",
    display: "flex",
    justifyContent: "center",
    // paddingBottom: "1rem",
  },
  sorryTitle: {
    fontSize: "4rem",
    fontWeight: "bolder",
    margin: "1rem 0 2rem 0",
    lineHeight: 1,
  },
  sorryPara: {
    fontSize: "16px",
    color: "#626b7e",
    width: "30vw",
    lineHeight: "1.5",
    textAlign: "center",
  },
  link: {
    fontSize: "16px",
    color: "#626b7e",
    width: "30vw",
    lineHeight: "35px",
    cursor: "pointer",
    marginRight: "0.75rem",
    paddingRight: "0.75rem",
    borderRight: "1px solid #d3dae3",
    textDecoration: "none",
    "&:hover": {
      color: "#ff4848",
    },
  },
  invalidContentContainer: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  reachiqLogo: {
    maxHeight: "100px",
    cursor: "pointer",
  },
  icon: {
    color: "#626b7e",
    transition: "100ms ease-in-out",
    marginRight: "8px",
    alignSelf: "center",
    cursor: "pointer",
    // "&:hover":{
    //     color:"#ff4848"
    // }
  },
  containIcons: {
    display: "flex",
    justifyContent: "space-around",
  },
  containFooter: {
    display: "flex",
    justifyContent: "space-between",
    padding: "2rem 5vw",
    borderTop: "1px solid #d3dae3",
    marginTop: "1rem",
  },
  btn: {
    background: "#ff4848",
    padding: "8px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    color: "white",
    marginTop: "1rem",
  },
});
